import { render, staticRenderFns } from "./CompanyTemplatesHandler.vue?vue&type=template&id=5d1a0b59&scoped=true&"
import script from "./CompanyTemplatesHandler.vue?vue&type=script&lang=js&"
export * from "./CompanyTemplatesHandler.vue?vue&type=script&lang=js&"
import style0 from "./CompanyTemplatesHandler.vue?vue&type=style&index=0&id=5d1a0b59&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1a0b59",
  null
  
)

export default component.exports